export default __webpack_public_path__ + "static/media/ErinGallagher.9dce1c61.jpg";